import React from "react";
import AccountProfile from "@/components/app/AccountProfile";

export default function AdminProfile() {
  return <AccountProfile testId="admin-profile" subtitle="Your super-admin account details and password." />;
}
